module.exports = __webpack_public_path__ + "static/img/qywh_jjgj.bfc4c6f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/qywh_jjgj.png
// module id = 6V76
// module chunks = 0